import { Component } from '@angular/core';

@Component({
  selector: 'empathy-input-description',
  templateUrl: 'input-description.component.html',
  styleUrls: ['./input-description.component.scss']
})
export class InputDescriptionComponent {}
